export interface WordmarkProps {
  /** Hides the word and shows the mark alone — the collapsed navigation rail. */
  readonly markOnly?: boolean;
  /** Accessible name for the link or button wrapping the mark. */
  readonly title?: string;
}

/**
 * The FieldOps mark and wordmark.
 *
 * The Clear monogram is drawn in a rounded tile, so it stays crisp at every
 * size and follows the theme. The word remains real, selectable text.
 *
 * The word is real text rather than outlines, so it is selectable, searchable
 * and reflows with the user's font size.
 *
 * @param props see {@link WordmarkProps}
 * @returns the lockup
 */
export function Wordmark({
  markOnly = false,
  title = 'FieldOps',
}: WordmarkProps): React.JSX.Element {
  return (
    <span className="fo-wordmark" data-mark-only={markOnly ? '' : undefined}>
      <svg
        className="fo-wordmark__mark"
        viewBox="0 0 32 32"
        role="img"
        aria-label={markOnly ? title : undefined}
        aria-hidden={markOnly ? undefined : true}
        focusable="false"
      >
        <rect width="32" height="32" rx="10" className="fo-wordmark__tile" />
        <path
          d="M12 23V9h9M12 15.5h7"
          className="fo-wordmark__leg"
          fill="none"
          strokeWidth="2.7"
          strokeLinecap="round"
        />
      </svg>
      {markOnly ? null : (
        <span className="fo-wordmark__text">
          Field<span className="fo-wordmark__text-accent">Ops</span>
        </span>
      )}
    </span>
  );
}
